let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8jC0S")).then(() => parcelRequire('j0e2J'));